import SectionCard from '@/components/molecule/SectionCard';
import { FormField } from '@/components/ui/form';
import Input from '@/components/atom/Input';
import Button from '@/components/atom/Button';
import { PlusIcon, X } from 'lucide-react';
import { BUTTON_CONST } from '@/src/constants/buttons';
import React, { ReactNode, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';

interface InfoData {
  id: number;
  contents: string;
}

interface Props {
  field: string;
  removeField?: string;
  form?: UseFormReturn<any, any, any>;
  cardTitle?: string | ReactNode;
  buttonText?: string;
}

function InfoFormSectionCard({
  removeField,
  form,
  field,
  cardTitle,
  buttonText,
}: Props) {
  const [isAdded, setIsAdded] = useState(false);

  return (
    <SectionCard
      cardTitle={cardTitle}
      className="flex h-max min-h-[520px] flex-col gap-4"
      contentProps={{
        className:
          'flex flex-col p-0 border border-gray0 flex-1 rounded-lg overflow-hidden',
      }}
    >
      <FormField
        control={form?.control}
        name={field}
        render={({ field }) => (
          <article
            className="flex h-[full] flex-col"
            style={{ overflow: 'overlay' }}
          >
            <header className="bg-gray0">
              <div className="flex h-[44px] text-b14m text-gray7">
                <div className="flex w-[70px] items-center justify-center border-r border-gray1">
                  No.
                </div>
                <div className="flex flex-1 items-center justify-center border-r border-gray1">
                  내용
                </div>
                <div className="flex w-[15%] min-w-[90px] max-w-[110px] items-center justify-center">
                  삭제
                </div>
              </div>
            </header>
            <div className="flex flex-1 flex-col gap-4 overflow-auto overflow-y-auto py-3">
              {((field.value as InfoData[]) || []).map((item, idx) => (
                <div key={item.id || idx + 1} className="flex">
                  <div className="flex w-[70px] items-center justify-center">
                    <p className="flex items-center justify-center px-2 text-b14r text-gray9">
                      {item?.id ? idx + 1 : '신규'}
                    </p>
                  </div>
                  <div className="flex flex-1 items-center justify-center">
                    <div className="flex w-full items-center justify-center px-2">
                      <Input
                        containerClassName="w-full"
                        size={32}
                        value={item.contents}
                        className="text-b14m"
                        placeholder="옵션 명을 입력해주세요"
                        onClear={() => {
                          const value = (field.value as InfoData[]) || [];
                          const newArray = value.map((mapItem, mapIdx) =>
                            mapIdx === idx
                              ? { ...mapItem, contents: '' }
                              : mapItem,
                          );

                          field.onChange(newArray);
                        }}
                        onChange={e => {
                          const value = (field.value as InfoData[]) || [];
                          const newArray = value.map((mapItem, mapIdx) =>
                            mapIdx === idx
                              ? { ...mapItem, contents: e.target.value }
                              : mapItem,
                          );

                          field.onChange(newArray);
                        }}
                        autoFocus={isAdded}
                      />
                    </div>
                  </div>

                  <div className="flex w-[15%] min-w-[90px] max-w-[110px] items-center justify-center">
                    <div className="flex w-full items-center justify-center px-2">
                      <Button
                        className="flex items-center gap-1"
                        buttonColor="red"
                        buttonSize="small"
                        onClick={() => {
                          const value = (field.value as InfoData[]) || [];
                          field.onChange(
                            value.filter((_, changeIdx) => changeIdx !== idx),
                          );

                          if (!item?.id) return;
                          if (!removeField) return;

                          form?.setValue(removeField, [
                            ...form.watch(removeField),
                            item.id,
                          ]);
                        }}
                      >
                        <X size={16} />
                        {BUTTON_CONST.delete}
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <footer>
              <div>
                <div className="w-full p-2">
                  <Button
                    buttonColor="outline"
                    className="flex w-full items-center gap-2"
                    onClick={() => {
                      const newArray = [...field.value, { contents: '' }];
                      setIsAdded(true);
                      field.onChange(newArray);
                    }}
                  >
                    <PlusIcon size={16} /> {buttonText || '안내사항 추가하기'}
                  </Button>
                </div>
              </div>
            </footer>
          </article>
        )}
      />
    </SectionCard>
  );
}

export default React.memo(InfoFormSectionCard);
